import AddIcon from "@mui/icons-material/Add";

import EditIcon from "@mui/icons-material/Edit";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as LinkRRD } from "react-router-dom";

import {
  Breadcrumbs,
  Button,
  Card,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Link,
  Menu,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { border, Box, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useCSVReader } from "react-papaparse";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import { Bolt } from "@mui/icons-material";
import Body from "../../layout/Body";
import AddPartner from "./AddPartner";
import { getAllPartnerAction } from "../../redux/toolkit/partner/allPartner";
import { useDispatch, useSelector } from "react-redux";
import { useStyles } from "../../theme/theme";
import EditPartner from "./EditPartner";
import LivePartner from "./LivePartner";
import Chip from "@mui/material/Chip";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { dateFormatStartFun } from "../../helper/dateConverter";
import { getAllPartnerRevenueAction } from "../../redux/toolkit/partner/allPartnerRevenue";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/partner"
      >
        Partner
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h4">
      Partners
    </Typography>
  </Stack>
);

const Partner = () => {
  const [createPartner, setCreatePartner] = useState(false);
  const [editPartnerShow, SetEditPartnerShow] = useState(false);
  const [partnerId, setPartnerId] = useState("");
  const [activePartner, setActivePartner] = useState(false);
  const [live, setLive] = useState(false);
  const [publisher, setPublisher] = useState("");
  console.log("publisher=====================>",publisher)

  const { data, message, totalPages, loading } = useSelector(
    (state) => state.allPartner
  );
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const classes = useStyles();
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  console.log("data", data);
  const getPublisherSelector = useSelector((state) => state.getPublisher);
  const { data: publiserData } = getPublisherSelector;

  // const {
  //   data: partnerRevenue,
  //   message: revenueMessage,
  //   totalPages: revenueTotalPages,
  //   loading: revenueLoading,
  // } = useSelector((state) => state.partnersRevenue);

  const dispatch = useDispatch();

  const dateWiseUser = () => {
    dispatch(
      getAllPartnerAction({
        page: pageState.page,
        pageSize: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        publisher_id: publisher?._id ? publisher?._id : null,
      })
    );
  };

  // const [mergedData, setMergedData] = useState([]);

  // useEffect(() => {
  //   if (data?.length && partnerRevenue) {
  //     const result = data.map((partner) => {
  //       const revenueObj = partnerRevenue.find(
  //         (rev) => rev.partner_id === partner._id
  //       );
  //       console.log("revenueObj", revenueObj);
  //       return {
  //         ...partner,
  //         totalPayout: revenueObj
  //           ? Number(revenueObj.publisher_payout)?.toFixed(4)
  //           : 0,
  //       };
  //     }
  //   );

  //     setMergedData(result);
  //   }
  // }, [data, partnerRevenue]);

  useEffect(() => {
    dispatch(
      getAllPartnerAction({
        page: pageState.page,
        pageSize: pageState.pageSize,
      })
    );
  }, [pageState.page, pageState.pageSize, dispatch]);

  const superAdminColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 80,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "name",
      headerName: "Partner Name",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "totalPayout",
      headerName: "Total Payout",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.totalPayout}</Typography>;
      },
    },

    {
      field: "attemptedSurvey",
      headerName: "Attempted Survey",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.attemptedSurvey}</Typography>;
      },
    },


    {
      field: "completedSurvey",
      headerName: "Compmeleted Survey ",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.completedSurvey}</Typography>;
      },
    },

    {
      field: "is_active",
      headerName: "Is Active",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography sx={{}}>
            {params?.row?.is_active ? (
              <button
                onClick={() => {
                  setLive(true);
                  setPartnerId(params?.row?._id);
                  setActivePartner(false);
                }}
              >
                {" "}
                <Chip label="Active" color="success" />
              </button>
            ) : (
              <button
                onClick={() => {
                  setLive(true);
                  setPartnerId(params?.row?._id);
                  setActivePartner(true);
                }}
              >
                {" "}
                <Chip label="Not Active" color="error" />
              </button>
            )}
          </Typography>
        );
      },
    },
    {
      field: "--",
      headerName: "Get Details",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          // <Button variant="contained" disableElevation>
          <LinkRRD to={`/single-partner?${params?.row?._id}`}>
            <Typography color="primary"> Get Details</Typography>
          </LinkRRD>
          // </Button>
        );
      },
    },

    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          // <Button variant="contained" disableElevation>
          //   <LinkRRD to={`/single-partner?${params?.row?._id}`}>
          //     <Typography color="primary"> Get Details</Typography>
          //   </LinkRRD>
          moment(params?.row?.created_at).format("DD-MM-YYYY hh:mm:ss A")
          // </Button>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              SetEditPartnerShow(true);
              setPartnerId(params?.row?._id);
            }}
            color="#071D45"
          >
            <EditIcon color="primary" />
          </IconButton>
        );
      },
    },
  ];

  const handleChange = (event) => {
    setPublisher(event.target.value);
  };

  useEffect(() => {
    dispatch(getPublisherAction());
  }, []);

  return (
    <>
      <Helmet>
        <title> Real Opinion Admin | Partners</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <Body>
        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignContent: "center",
          }}
        >
          <Stack direction="row" sx={{ mr: 2 }}>
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Publisher</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={publisher?.name} // ✅ Correct binding
                  label="Publisher"
                  onChange={handleChange} // ✅ Fixes event handling
                >
                  {publiserData?.map((item, i) => (
                    <MenuItem key={i} value={item}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>

          <Stack direction="row" spacing={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, startDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="End Date"
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, endDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            { (date?.startDate && date?.endDate) && (
              <Button variant="contained" onClick={dateWiseUser}>
                find data
              </Button>
            )}
          </Stack>

          <Stack direction="row" spacing={0} sx={{ ml: 2 }}>
            <Button
              variant="contained"
              color="btn"
              startIcon={<AddIcon />}
              onClick={() => {
                setCreatePartner(true);
              }}
            >
              create Partner
            </Button>
          </Stack>
        </Stack>

        <Card sx={{ my: 2 }}>
          <Stack direction={"row"} alignItems="center" sx={{ ml: 1 }}>
            <Typography sx={{ my: 1 }} variant="h6">
              Admin / Support Logs List
            </Typography>
          </Stack>

          {/* table list */}
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={superAdminColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                // Toolbar: GridToolbar,
              }}
              rowCount={totalPages}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>

        {createPartner && (
          <AddPartner
            partnerId={partnerId}
            state={createPartner}
            setState={setCreatePartner}
          />
        )}
        {editPartnerShow && (
          <EditPartner
            partnerId={partnerId}
            state={editPartnerShow}
            setState={SetEditPartnerShow}
          />
        )}
        {live && (
          <LivePartner
            is_active={activePartner}
            state={live}
            setState={setLive}
            id={partnerId}
          />
        )}
      </Body>
    </>
  );
};

export default Partner;
